import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormat',
  standalone: false,
})
export class CurrencyFormatPipe implements PipeTransform {
  transform(
    value: unknown, // 👈 değiştiriyoruz!
    currency: string = 'TRY',
    thousands: string = '.',
    decimal: string = ',',
    decimals: number = 2,
  ): string {
    if (
      value === null ||
      value === undefined ||
      value === '' ||
      (typeof value !== 'string' && typeof value !== 'number')
    ) {
      return `0`;
    }

    try {
      const numValue = typeof value === 'string' ? parseFloat(value) : value;

      if (isNaN(numValue)) {
        return `0`;
      }

      // Yerel ayraçlar
      switch (currency) {
        case 'TRY':
        case 'EUR':
          thousands = '.';
          decimal = ',';
          break;
        case 'USD':
        case 'GBP':
          thousands = ',';
          decimal = '.';
          break;
      }

      const fixedValue = Number(numValue).toFixed(decimals);
      const [intPart, decPart] = fixedValue.split('.');

      const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const decimalStr = decimals > 0 && decPart ? `${decimal}${decPart}` : '';

      return `${formattedInt}${decimalStr}`;
    } catch (error) {
      console.error('Currency formatting error:', error);
      return `0`;
    }
  }
}
